import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
   return (
      <Box
         sx={{
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: 'background.default',
         }}
      >
         <Container
            maxWidth='sm'
            sx={{
               p: { xs: 2, sm: 3, md: 4 },
               display: 'flex',
               flexDirection: 'column',
               justifyContent: 'center',
               alignItems: 'center',
               minHeight: '100vh',
            }}
         >
            {children}
         </Container>
      </Box>
   );
};

export default AuthLayout;
